import { render } from "./history-view.vue?vue&type=template&id=3f84fb12&scoped=true&ts=true"
import script from "./history-view.vue?vue&type=script&lang=ts"
export * from "./history-view.vue?vue&type=script&lang=ts"

import "./history-view.vue?vue&type=style&index=0&id=3f84fb12&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f84fb12"]])

export default __exports__